module.exports = __webpack_public_path__ + "img/Upload.19a0eb65.svg";